import { queryOptions } from "@tanstack/react-query";
import { createServerFn } from "@tanstack/react-start";
import z from "zod";

import { requirePermissions } from "@/auth/shared";
import { db } from "@/db/connection";

const getInviteSourcesSchema = z.object({
  targetTournamentId: z.number(),
});

export const getInviteSourcesFn = createServerFn({
  method: "GET",
})
  .middleware([requirePermissions({ tournaments: ["create"] })])
  .inputValidator(getInviteSourcesSchema)
  .handler(async ({ data: { targetTournamentId } }) => {
    return db.query.tournamentInviteSources.findMany({
      where: {
        targetTournamentId,
      },
      with: {
        sourceTournamentDivision: {
          columns: {
            id: true,
            name: true,
            gender: true,
            teamSize: true,
            displayGender: true,
            displayDivision: true,
          },
          with: {
            tournament: {
              columns: {
                id: true,
                date: true,
              },
              with: {
                venue: {
                  columns: {
                    name: true,
                    city: true,
                  },
                },
              },
            },
            division: {
              columns: {
                id: true,
                name: true,
                display: true,
                maxAge: true,
              },
            },
          },
        },
      },
    });
  });

export const getInviteSourcesQueryOptions = (targetTournamentId: number) =>
  queryOptions({
    queryKey: ["invite-sources", targetTournamentId],
    queryFn: () => getInviteSourcesFn({ data: { targetTournamentId } }),
  });
